import * as React from 'react';
import { FieldPath } from 'react-hook-form';

import { RHFTextInput } from 'components/input/RHFTextInput';
import { NormalizedLoad } from 'types/Load';

export type LoadBuildingTextInputProps = React.ComponentPropsWithoutRef<
  typeof RHFTextInput
> & {
  name: FieldPath<NormalizedLoad>;
};

export function LoadBuildingTextInput(props: LoadBuildingTextInputProps) {
  return <RHFTextInput {...props} />;
}
